import { render } from "./VenueTitle.vue?vue&type=template&id=0b228e68"
import script from "./VenueTitle.js?vue&type=script&lang=js"
export * from "./VenueTitle.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__